import type { CSSProperties } from 'react';
import type { ToastType } from '../types';

// Цвет иконки и полоски и подложка круга — токены темы (role.telecom.css).
export const COLOR: Record<ToastType, { color: string; tint: string }> = {
  success: { color: 'var(--toast-success)', tint: 'var(--toast-success-tint)' },
  error: { color: 'var(--toast-error)', tint: 'var(--toast-error-tint)' },
  warning: { color: 'var(--toast-warning)', tint: 'var(--toast-warning-tint)' },
  info: { color: 'var(--toast-info)', tint: 'var(--toast-info-tint)' },
};

export const cardStyle = (type: ToastType): CSSProperties =>
  ({
    display: 'flex',
    alignItems: 'center',
    // Ширину задаёт контейнер (340px, на телефоне — экран): у плашки
    // react-toastify своя, 320px.
    width: '100%',
    gap: '12px',
    background: 'var(--surface-card)',
    color: 'var(--text-primary)',
    borderRadius: '14px',
    boxShadow: 'var(--toast-shadow)',
    padding: '14px 12px 14px 14px',
    minHeight: '0',
    marginBottom: '10px',
    fontFamily: 'var(--font-app)',
    '--tc-toast-color': COLOR[type].color,
  }) as CSSProperties;

// Узкий экран — телефон: во всю ширину под верхней панелью (60px).
export const isPhone = (width: number) => width < 640;

